import React from 'react';
import { useModal } from 'mui-modal-provider';
import { useIntl } from 'react-intl';

import { BirthdayModal } from '../birthday-modal';
import { FormattedMessage } from 'react-intl';
import { useStyles } from '../field.styles';

import icon from '../../../../../../assets/images/icons/calendar/calendar.svg';

export const Birthday = ({ onSetDate, date }: { onSetDate: (date: Date) => void, date?: Date }): JSX.Element => {
  const { showModal } = useModal();
  const intl = useIntl();
  const classes = useStyles();

  const handleBirthdayChange = () => {
    showModal(BirthdayModal, { onSetDate, dateDefault: date });
  };

  return (
    <>
      <div className={classes.wrapper} data-testid="birthday">
        <h3 className={classes.title}>
          <FormattedMessage id="profile.dateOfBirthTextField.label" />
          <span className={classes.asterisk}>*</span>
        </h3>
        {date && (<span>{new Date(date).toLocaleDateString(intl.locale, {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
        })}</span>)}
        <button
          type="button"
          onClick={handleBirthdayChange}
          className={classes.button}
          aria-label={intl.formatMessage({ id: 'common.change' })}
        >
          <img className={classes.icon} src={icon} alt="" />
        </button>
      </div>
      {date && <p className={classes.disclaimer}>{intl.formatMessage({ id: 'createKidsProfile.date.disclaimer' })}</p>}
    </>
  );
};
